import { z } from 'zod';

export const getQuestionsSchema = z.object({
  module_id: z.uuid('Invalid module ID').optional(),
  category_id: z.uuid('Invalid category ID').optional(),
  search: z.string().optional(),
  limit: z
    .string()
    .optional()
    .default('50')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
});

export const getQuestionSchema = z.object({
  question_id: z.uuid('Invalid question ID'),
});

export const deleteQuestionSchema = z.object({
  question_id: z.uuid('Invalid question ID'),
});

export type GetQuestionsPayload = z.infer<typeof getQuestionsSchema>;
export type GetQuestionPayload = z.infer<typeof getQuestionSchema>;
export type DeleteQuestionPayload = z.infer<typeof deleteQuestionSchema>;
